import { utilStyles } from '@Utils/utilStyles';
import { MaterialIcons } from '@expo/vector-icons';
import React from 'react';
import { View } from 'react-native';

type Props = {
  x?: number;
  y?: number;
  size?: number;
};
export function MapPointer({ x = 0, y = 0, size = 13 }: Props) {
  return (
    <View
      style={[
        utilStyles.absolute,
        {
          //   The bottom notch of the icon points to x,y location
          top: y - size,
          left: x - size / 2,
          width: size,
          height: size,
        },
      ]}
    >
      <MaterialIcons name='location-pin' color='red' size={size} />
    </View>
  );
}
